module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-arrow-nav",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg-icon', {
    staticClass: "back-arrow-nav__arrow",
    attrs: {
      "icon": _vm.backArrowIcon,
      "height": 40,
      "width": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "back-arrow-nav__message"
  }, [_vm._v("Back")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6890387e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/backArrowNav/BackArrowNav.vue
// module id = 1923
// module chunks = 0